// extracted by mini-css-extract-plugin
export default {"socialLoginButton":"styles_socialLoginButton__nyTlD"};